import { parsePortalConfigJson, type PortalConfig } from "./portal-config";

/**
 * Absolute URL for `config.json` (honours Vite `base` / `import.meta.env.BASE_URL`).
 * Resolves against the current document URL so subpaths work with `base: "./"`.
 */
export function resolveConfigJsonHref(
  viteBaseUrl: string,
  pageHref: string,
): string {
  const base = viteBaseUrl || "/";
  const path = base.endsWith("/") ? `${base}config.json` : `${base}/config.json`;
  return new URL(path, pageHref).href;
}

export async function loadRuntimePortalConfig(
  fetchImpl: typeof fetch,
  location: Pick<Location, "origin" | "pathname" | "href">,
  viteBaseUrl: string,
): Promise<PortalConfig> {
  const url = resolveConfigJsonHref(viteBaseUrl, location.href);
  const res = await fetchImpl(url, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(
      `Failed to load config.json (${res.status} ${res.statusText}): ${url}`,
    );
  }
  let data: unknown;
  try {
    data = await res.json();
  } catch {
    throw new Error(`config.json is not valid JSON: ${url}`);
  }
  return parsePortalConfigJson(data, {
    origin: location.origin,
    pathname: location.pathname,
  });
}
